import { React, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	Typography,
	FormHelperText,
} from "@mui/material";
import {
	useAddCategoryGroupMutation,
	useCategoriesQuery,
} from "../../../services/queryHooks";
import { useTranslation } from "react-i18next";
import { validateTextField } from "../../../utils/validation";
import ColorDisplayAndPicker from "../../../components/common/ColorDisplayAndPicker";

export default function AddCategoryGroupModal({ isOpen, onClose }) {
	const [categoryType, setCategoryType] = useState("");
	const [groupName, setGroupName] = useState("");
	const [errorCategoryType, setErrorCategoryType] = useState("");
	const [errorGroupName, setErrorGroupName] = useState("");
	const { mutate, isError, error, reset } = useAddCategoryGroupMutation();
	const { t } = useTranslation();
	const [color, setColor] = useState("");

	const { data: categories } = useCategoriesQuery();

	const handleCloseModal = () => {
		setCategoryType("");
		setGroupName("");
		setErrorCategoryType("");
		setErrorGroupName("");
		setColor("");
		reset();
		onClose();
	};

	const submitForm = (event) => {
		event.preventDefault();
		if (errorCategoryType || errorGroupName) return;
		mutate({ type: categoryType, groupName: groupName, color: color });
		handleCloseModal();
	};

	const validateInputs = () => {
		let isValid = true;
		setErrorCategoryType("");
		setErrorGroupName("");
		if (!categoryType) {
			isValid = false;
			setErrorCategoryType(t("categoryTypeError"));
		}
		const groupNameError = validateTextField(groupName, t, {
			fieldName: t("categoryGroupName"),
		});

		if (groupNameError) {
			setErrorGroupName(groupNameError);
			isValid = false;
		} else if (
			categories.some(
				(cat) =>
					cat.type === categoryType &&
					(
						cat.groupName || t(cat.groupTranslationKey)
					)?.toLowerCase() === groupName.trim().toLowerCase()
			)
		) {
			isValid = false;
			setErrorGroupName(t("groupNameExistsError"));
		}
		return isValid;
	};

	return (
		<>
			<Dialog open={isOpen} onClose={onClose} disableEnforceFocus>
				<DialogTitle>{t("addCategoryGroup")}</DialogTitle>
				<form noValidate onSubmit={submitForm}>
					<DialogContent>
						<TextField
							autoFocus
							label={t("categoryGroupName")}
							value={groupName}
							onChange={(e) => setGroupName(e.target.value)}
							type="text"
							fullWidth
							error={errorGroupName ? true : false}
							helperText={errorGroupName}
						/>
						<FormControl
							fullWidth
							sx={{ mt: 2 }}
							error={errorCategoryType ? true : false}
						>
							<InputLabel>{t("categoryGroupType")}</InputLabel>
							<Select
								id="categoryGroupType"
								value={categoryType}
								label={t("categoryGroupType")}
								onChange={(e) =>
									setCategoryType(e.target.value)
								}
							>
								<MenuItem value="income">
									{t("income")}
								</MenuItem>
								<MenuItem value="expense">
									{t("expense")}
								</MenuItem>
							</Select>
							{errorCategoryType && (
								<FormHelperText sx={{ ml: 0 }}>
									{errorCategoryType}
								</FormHelperText>
							)}
						</FormControl>
						<FormControl
							sx={{
								mt: 2,
								display: "flex",
								flexDirection: "row",
								alignItems: "baseLine",
								gap: 1,
							}}
						>
							<Typography
								component="span"
								variant="subtitle1"
								gutterBottom
							>
								{t("pickCategoryGroupColor") + ":"}
							</Typography>
							<ColorDisplayAndPicker
								color={color}
								onColorChange={(newColor) => setColor(newColor)}
								isEditable={true}
							/>
						</FormControl>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleCloseModal}>
							{t("cancel")}
						</Button>
						<Button
							type="submit"
							variant="contained"
							onClick={validateInputs}
						>
							{t("save")}
						</Button>
						{isError && <p>Błąd: {error.message}</p>}
					</DialogActions>
				</form>
			</Dialog>
		</>
	);
}
